import { ServicePage } from '@/components/ui/page-templates/ServicePage';
import { ConsultancyContent } from '@/components/shared';

export function ConsultingPage() {
  const breadcrumbs = [
    { label: "Services", href: "/services" },
    { label: "Consulting", href: "/services/consulting", current: true }
  ];

  return (
    <ServicePage
      title="Consulting Services"
      description="Expert guidance for businesses at every stage of growth, from fast-growing startups to established SMBs."
      breadcrumbs={breadcrumbs}
      category="Professional Services"
      accentColor="#1e293b"
    >
      <ConsultancyContent />
    </ServicePage>
  );
}